import React from 'react'
import AnalyzerDemoData from 'Pages/AnalyzersV2/@tour/DemoData'
import { demoPopoverOpen } from './signals'

// Demo shown by the Virtual Tour when no report is loaded: one column per length of rental
const ROWS = [
	{ name: 'alphacars', country: 'GB', prices: [179.41, 260.28, 313.58, 682.85] },
	{ name: 'peakrentals', country: 'GB', prices: [102.33, 139.03, 198.11, 452.76] },
	{ name: 'eurodrive', country: 'GB', prices: [105.77, 139.44, 191.82, 355.45] },
	{ name: 'horizoncars', country: 'GB', prices: [106.38, 200.88, 237.11, 450.50] },
	{ name: 'swiftfleet', country: 'GB', prices: [106.98, 170.95, 179.93, 645.90] },
]

const COLUMNS = [3, 5, 7, 14].map(lor => ({ label: String(lor) }))

export default function LorDemoData() {
	return <AnalyzerDemoData
		demoPopoverOpen={demoPopoverOpen}
		columns={COLUMNS}
		rows={ROWS}
		chart={{ title: 'Length of Rental', type: 'line' }}
		pickup="05 Jan 2025"
	/>
}
